import React from 'react';

interface FactoryIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
}

const FactoryIcon: React.FC<FactoryIconProps> = ({
  fillColor = '#AAAAAA',
  ...rest
}) => {
  return (
    <svg
      {...rest}
      width="20"
      height="25"
      viewBox="0 0 20 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="factory/Default">
        <path
          id="Path"
          d="M3.40381 10.4945L6.19018 9.43522V2.63672H3.40381V10.4945Z"
          fill={fillColor}
        />
        <path
          id="Path_2"
          d="M11.0415 10.4945L13.83 9.43522V2.63672H11.0415V10.4945Z"
          fill={fillColor}
        />
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 24.4922H0V17.1709H20V24.4922ZM11.7238 18.2988H9.57848V21.9927H11.7238V18.2988ZM5.78642 18.2988H7.93281V21.9927H5.78642V18.2988ZM3.9983 18.2988H1.85404V21.9927H3.9983V18.2988Z"
          fill={fillColor}
        />
        <path
          id="Path_3"
          d="M15.2777 12.836L14.7302 9.8457L7.7776 12.836L6.9452 9.8457L0 12.836V16.0242H19.9989V12.836H15.2777Z"
          fill={fillColor}
        />
        <path
          id="Path_4"
          d="M2.14435 2.14949C2.49411 2.07856 2.76414 1.86693 2.97782 1.63585C3.20001 1.40134 3.3701 1.16683 3.62418 1.02612C3.86444 0.880843 4.17061 0.839661 4.36835 0.881987C4.55758 0.917449 4.67877 1.00553 4.8191 1.23776C4.95092 1.45968 5.0466 1.74224 5.16354 2.03852H5.21989C5.31982 1.7205 5.32407 1.38189 5.22308 1.03985C5.16992 0.869403 5.0785 0.694379 4.92541 0.555961C4.77551 0.414111 4.55333 0.346617 4.36941 0.369496C3.9867 0.41983 3.76238 0.679507 3.52425 0.857964C3.28931 1.041 3.04586 1.24004 2.79922 1.35901C2.54514 1.47684 2.29212 1.55806 2.071 1.57293C1.84669 1.57865 1.67234 1.50086 1.49799 1.35787C1.1376 1.0696 0.849506 0.537657 0.546524 0L0.49018 0.0114395C0.451908 0.656628 0.596489 1.34529 1.11528 1.86807C1.37893 2.12203 1.79779 2.23757 2.14435 2.14949Z"
          fill={fillColor}
        />
        <path
          id="Path_5"
          d="M10.7754 2.20237C11.039 2.14403 11.2262 1.9793 11.3739 1.79741C11.5174 1.62353 11.6354 1.45079 11.8098 1.36042C11.9778 1.26319 12.2021 1.27005 12.3116 1.31238C12.4104 1.35127 12.4572 1.36614 12.5635 1.51142C12.6592 1.64755 12.7421 1.83516 12.8559 2.03764H12.9133C13.0164 1.81343 13.0313 1.56976 12.9675 1.31352C12.9324 1.18654 12.8644 1.05155 12.7474 0.942879C12.6326 0.829628 12.4551 0.779294 12.3137 0.799885C12.0213 0.849075 11.8746 1.06185 11.7109 1.19226C11.5483 1.32953 11.3739 1.45194 11.1921 1.52401C11.0135 1.58349 10.8371 1.62467 10.7052 1.62582C10.5681 1.61781 10.482 1.56862 10.3757 1.4874C10.1492 1.32153 9.92705 0.977198 9.6634 0.619141L9.60706 0.631724C9.52732 1.09617 9.60706 1.59722 9.99083 1.9976C10.1907 2.19093 10.516 2.27673 10.7754 2.20237Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default FactoryIcon;
